<template>
  <b-form-group v-if="telefones.length" label="Telefones:">
    <b-list-group v-if="!loading">
      <b-list-group-item
        v-for="telefone in telefones"
        :key="telefone.ID_EMITENTE_TELEFONE_TODOS"
      >
        {{ telefone.TIPO }}: ({{ telefone.DDD }})
        {{ telefone.TELEFONE }}
        <b-badge
          pill
          variant="primary"
          v-if="telefone.E_CELULAR == '1'"
          style="padding: 3px; margin-left: 5px;"
        >
          Celular
        </b-badge>
      </b-list-group-item>
    </b-list-group>
    <Loading v-if="loading" :modoPR="pagRec" tamanho="100px" />
  </b-form-group>
</template>

<style lang="scss" scoped></style>

<script>
export default {
  name: "EmitenteTelefones",
  props: ["telefones", "loading", "pagRec"]
};
</script>
